import { css, SerializedStyles } from '@emotion/react';
import { EmotionTheme } from 'src/domains/layouts/state/environmentState/EnvironmentState';

// Emitted for any operator using the Optimove host div — prevents SDK self-positioning.
export const optimoveBadgePositionStyle = (hostId: string): SerializedStyles => css`
    /* stylelint-disable custom-property-pattern, custom-property-empty-line-before */
    :root {
        --optimove_inbox_badge_position: static;
        --optimove_inbox_badge_top: auto;
        --optimove_inbox_badge_right: auto;
        --optimove_inbox_badge_bottom: auto;
        --optimove_inbox_badge_left: auto;
    }

    /* stylelint-disable-next-line selector-id-pattern */
    #${hostId}:not([data-open]) {
        transition: transform 200ms ease;
    }

    /* stylelint-disable-next-line selector-id-pattern */
    #${hostId}:not([data-open]):hover {
        transform: scale(1.08);
    }
`;

// Emitted only for operators with custom brand styling (optimoveInboxCustomised: true).
export const optimoveInboxCustomStyle = (theme: EmotionTheme): SerializedStyles => {
    const t = theme.star.optimoveInbox;
    return css`
        :root {
            /* typography */
            ${t.typography.fontFamily ? `--optimove_inbox_font_family: ${t.typography.fontFamily};` : ''}

            /* inbox panel */
            --optimove_inbox_width: 380px;
            --optimove_inbox_height: 520px;
            --optimove_inbox_vertical_align: end;
            --optimove_inbox_margin_top: 350px;
            --optimove_inbox_margin_bottom: 80px;
            --optimove_inbox_margin_horizontal: 24px;
            --optimove_inbox_padding: 8px;
            --optimove_inbox_padding_top: 12px;
            ${t.bgColor ? `--optimove_inbox_background_color: ${t.bgColor};` : ''}

            /* header */
            --optimove_inbox_header_text_font_size: 16px;
            --optimove_inbox_header_font_weight: 700;
            ${t.header.bgColor ? `--optimove_inbox_header_background_color: ${t.header.bgColor};` : ''}
            ${t.header.txtColor ? `--optimove_inbox_header_text_color: ${t.header.txtColor};` : ''}
            ${t.header.txtColor ? `--optimove_inbox_header_bell_fill: ${t.header.txtColor};` : ''}
            ${t.header.txtColor ? `--optimove_inbox_header_close_button_fill: ${t.header.txtColor};` : ''}
            ${t.header.bellBgColor ? `--optimove_inbox_header_bell_background: ${t.header.bellBgColor};` : ''}
            ${t.header.closeBtnBgColor ? `--optimove_inbox_header_close_button_background: ${t.header.closeBtnBgColor};` : ''}

            /* message */
            --optimove_inbox_message_border_radius: 8px;
            --optimove_inbox_message_images_border_radius: 8px;
            --optimove_inbox_message_images_small_border_radius: 4px;
            --optimove_inbox_message_images_small_width: 72px;
            --optimove_inbox_message_images_small_height: 72px;
            --optimove_inbox_message_bottom_margin: 8px;
            --optimove_inbox_message_title_font_size: 15px;
            --optimove_inbox_message_title_font_weight: 700;
            --optimove_inbox_message_title_padding_bottom: 6px;
            --optimove_inbox_message_content_font_size: 13px;
            --optimove_inbox_message_font_weight: 400;
            ${t.message.bgColorUnread ? `--optimove_inbox_message_background_unread: ${t.message.bgColorUnread};` : ''}
            ${t.message.bgColorRead ? `--optimove_inbox_message_background_read: ${t.message.bgColorRead};` : ''}
            ${t.message.titleTxtColor ? `--optimove_inbox_message_title_font_color: ${t.message.titleTxtColor};` : ''}
            ${t.message.bodyTxtColor ? `--optimove_inbox_message_font_color: ${t.message.bodyTxtColor};` : ''}
            ${t.message.accentColor ? `--optimove_inbox_message_default_media_color: ${t.message.accentColor};` : ''}
            ${t.message.accentColor ? `--optimove_inbox_message_action_button_color: ${t.message.accentColor};` : ''}
            ${t.message.actionBtnBgColor ? `--optimove_inbox_message_action_button_background_color: ${t.message.actionBtnBgColor};` : ''}

            /* action menu */
            --optimove_inbox_action_menu_hover_scale: scale(1.05);
            --optimove_inbox_action_menu_hover_transition: 200ms;
            --optimove_inbox_action_menu_font_size: 14px;
            --optimove_inbox_action_menu_icon_size: 18px;
            --optimove_inbox_action_menu_icon_padding: 8px;
            ${t.actionMenu.bgColor ? `--optimove_inbox_action_menu_background_color: ${t.actionMenu.bgColor};` : ''}
            ${t.actionMenu.txtColor ? `--optimove_inbox_action_menu_color: ${t.actionMenu.txtColor};` : ''}
            ${t.actionMenu.txtColorHover ? `--optimove_inbox_action_menu_hover_color: ${t.actionMenu.txtColorHover};` : ''}

            /* badge */
            --optimove_inbox_badge_width: 52px;
            --optimove_inbox_badge_height: 44px;
            --optimove_inbox_badge_border_radius: 50%;
            --optimove_inbox_badge_alert_border_radius: 50%;
            --optimove_inbox_badge_alert_width: 20px;
            --optimove_inbox_badge_alert_height: 20px;
            ${t.badge.bgColor ? `--optimove_inbox_badge_background_color: ${t.badge.bgColor};` : ''}
            ${t.badge.txtColor ? `--optimove_inbox_badge_bell_color: ${t.badge.txtColor};` : ''}
            ${t.badge.borderColor ? `--optimove_inbox_badge_border: 2px solid ${t.badge.borderColor};` : ''}
            ${t.badge.alertBgColor ? `--optimove_inbox_badge_alert_background_color: ${t.badge.alertBgColor};` : ''}
            ${t.badge.alertTxtColor ? `--optimove_inbox_badge_alert_font_color: ${t.badge.alertTxtColor};` : ''}
        }
    `;
};
